class NoteController implements ng.IComponentController {

    constructor(
    ) {
        'ngInject';
    }

}

export const noteComponent: ng.IComponentOptions = {
    controller: NoteController,
    template: <string>require('./note.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/notes/note.component.ts